export default (input: string): string => input[0].toUpperCase() + input.substr(1);
